import axiosInstance from "../../api/axiosInstance";
import {
  CREATE_GIFT_CREATE_FAIL,
  CREATE_GIFT_CREATE_REQUEST,
  CREATE_GIFT_CREATE_SUCCESS,
  FETCH_GIFT_LIST_REQUEST,
  FETCH_GIFT_LIST_SUCCESS,
  FETCH_GIFT_LIST_FAIL,
  CREATE_GIFT_MASTER_CREATE_FAIL,
  CREATE_GIFT_MASTER_CREATE_REQUEST,
  CREATE_GIFT_MASTER_CREATE_SUCCESS,
  FETCH_GIFT_MASTER_REQUEST,
  FETCH_GIFT_MASTER_SUCCESS,
  FETCH_GIFT_MASTER_FAIL,
  FETCH_OFFER_SCHEME_REQUEST,
  FETCH_OFFER_SCHEME_SUCCESS,
  FETCH_OFFER_SCHEME_FAIL,
  FETCH_GIFTS_BY_SCHEME_REQUEST,
  FETCH_GIFTS_BY_SCHEME_SUCCESS,
  FETCH_GIFTS_BY_SCHEME_FAIL,
  UPDATE_GIFT_MASTER_REQUEST,
  UPDATE_GIFT_MASTER_SUCCESS,
  UPDATE_GIFT_MASTER_FAILED,
  ADD_GIFT_TO_SCHEME_REQUEST,
  ADD_GIFT_TO_SCHEME_SUCCESS,
  ADD_GIFT_TO_SCHEME_FAIL,
} from "../actionTypes";

export const CreateGiftAllocate = (GiftData, token) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_GIFT_CREATE_REQUEST });
    try {
      const response = await axiosInstance.post(
        "/api/create-gift-allotment/",
        GiftData, // This now includes all 8 fields
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: CREATE_GIFT_CREATE_SUCCESS,
        payload: response.data,
      });
      return { type: CREATE_GIFT_CREATE_SUCCESS, payload: response.data };
    } catch (error) {
      const errorPayload = error.response
        ? error.response.data
        : "Network Error";
      dispatch({
        type: CREATE_GIFT_CREATE_FAIL,
        payload: errorPayload,
      });
      return { type: CREATE_GIFT_CREATE_FAIL, payload: errorPayload };
    }
  };
};
export const FetchGiftAllocate = (token, params = {}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_GIFT_LIST_REQUEST });
    try {
      const response = await axiosInstance.get("/api/get-gift-allotments/", {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch({
        type: FETCH_GIFT_LIST_SUCCESS,
        payload: response.data,
      });
      return { type: FETCH_GIFT_LIST_SUCCESS, payload: response.data };
    } catch (error) {
      const errorPayload = error.response
        ? error.response.data
        : "Network Error";
      dispatch({
        type: FETCH_GIFT_LIST_FAIL,
        payload: errorPayload,
      });
      return { type: FETCH_GIFT_LIST_FAIL, payload: errorPayload };
    }
  };
};

export const createMassterGiftAction = (GiftData, token) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_GIFT_MASTER_CREATE_REQUEST });
    try {
      const response = await axiosInstance.post(
        "/api/create-gift-masters/",
        GiftData, // This now includes all 8 fields
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: CREATE_GIFT_MASTER_CREATE_SUCCESS,
        payload: response.data,
      });
      return {
        type: CREATE_GIFT_MASTER_CREATE_SUCCESS,
        payload: response.data,
      };
    } catch (error) {
      const errorPayload = error.response
        ? error.response.data
        : "Network Error";
      dispatch({
        type: CREATE_GIFT_MASTER_CREATE_FAIL,
        payload: errorPayload,
      });
      return { type: CREATE_GIFT_MASTER_CREATE_FAIL, payload: errorPayload };
    }
  };
};

// export const updateMassterGiftAction = (GiftData, token) => {

//   return async (dispatch) => {
//     dispatch({ type: UPDATE_GIFT_MASTER_REQUEST });
//     try {
//       // Send individual gift updates
//       const updatePromises = GiftData.gifts.map((gift) => {
//         const payload = {
//           gift_id: gift.gift_id || null,
//           gift_name: gift.gift_name,
//           gift_image: gift.gift_image,
//           qr_count: gift.qr_count !== undefined ? gift.qr_count : null,
//           is_additional_gift: gift.is_additional_gift !== undefined ? gift.is_additional_gift : null,
//           is_live: gift.is_live !== undefined ? gift.is_live : null,
//           expired_at: gift.expired_at || null,
//         };

//         return axiosInstance.post("/api/update-gift-master/", payload, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         });
//       });

//       const responses = await Promise.all(updatePromises);

//       dispatch({
//         type: UPDATE_GIFT_MASTER_SUCCESS,
//         payload: responses[0]?.data,
//       });

//       return {
//         type: UPDATE_GIFT_MASTER_SUCCESS,
//         payload: responses[0]?.data,
//       };
//     } catch (error) {
//       const errorPayload = error.response
//         ? error.response.data
//         : "Network Error";
//       dispatch({
//         type: UPDATE_GIFT_MASTER_FAILED,
//         payload: errorPayload,
//       });
//       return { type: UPDATE_GIFT_MASTER_FAILED, payload: errorPayload };
//     }
//   };
// };

export const updateMassterGiftAction = (GiftData, token) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_GIFT_MASTER_REQUEST });
    try {
      // The payload structure should match what you're sending from the component
      const payload = {
        offer_scheme_id: GiftData.offer_scheme_id,  // ✅ Make sure this is included
        offer_scheme_name: GiftData.offer_scheme_name,
        gifts: GiftData.gifts,  // Keep the gifts array as-is from the component
      };

      console.log("Redux Action Payload:", JSON.stringify(payload, null, 2));

      const response = await axiosInstance.post(
        "/api/update-gift-master/",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      dispatch({
        type: UPDATE_GIFT_MASTER_SUCCESS,
        payload: response.data,
      });

      return {
        type: UPDATE_GIFT_MASTER_SUCCESS,
        payload: response.data,
      };
    } catch (error) {
      const errorPayload = error.response
        ? error.response.data
        : "Network Error";
      dispatch({
        type: UPDATE_GIFT_MASTER_FAILED,
        payload: errorPayload,
      });
      return { type: UPDATE_GIFT_MASTER_FAILED, payload: errorPayload };
    }
  };
};
export const addGiftToSchemeAction = (giftData, token) => {
  return async (dispatch) => {
    dispatch({ type: ADD_GIFT_TO_SCHEME_REQUEST });
    try {
      const response = await axiosInstance.post(
        "/api/add-gift-to-scheme/",
        giftData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      dispatch({
        type: ADD_GIFT_TO_SCHEME_SUCCESS,
        payload: response.data,
      });
      return { type: ADD_GIFT_TO_SCHEME_SUCCESS, payload: response.data };
    } catch (error) {
      const errorPayload = error.response
        ? error.response.data
        : "Network Error";
      dispatch({
        type: ADD_GIFT_TO_SCHEME_FAIL,
        payload: errorPayload,
      });
      return { type: ADD_GIFT_TO_SCHEME_FAIL, payload: errorPayload };
    }
  };
};

export const FetchMasterGiftAction = (token, params = {}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_GIFT_MASTER_REQUEST });
    try {
      const response = await axiosInstance.get("/api/get-gift-masters/", {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch({
        type: FETCH_GIFT_MASTER_SUCCESS,
        payload: response.data.data,
      });
      return { type: FETCH_GIFT_MASTER_SUCCESS, payload: response.data.data };
      console.log("response.data.data", response.data.data);
    } catch (error) {
      const errorPayload = error.response
        ? error.response.data
        : "Network Error";
      dispatch({
        type: FETCH_GIFT_MASTER_FAIL,
        payload: errorPayload,
      });
      return { type: FETCH_GIFT_MASTER_FAIL, payload: errorPayload };
    }
  };
};
export const FetchOfferSchemeAction = (token, params = {}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_OFFER_SCHEME_REQUEST });
    try {
      const response = await axiosInstance.get("/api/get-offer-schemes/", {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch({
        type: FETCH_OFFER_SCHEME_SUCCESS,
        payload: response.data.data,
      });
      return { type: FETCH_OFFER_SCHEME_SUCCESS, payload: response.data.data };
      console.log("response.data.data", response.data.data);
    } catch (error) {
      const errorPayload = error.response
        ? error.response.data
        : "Network Error";
      dispatch({
        type: FETCH_OFFER_SCHEME_FAIL,
        payload: errorPayload,
      });
      return { type: FETCH_OFFER_SCHEME_FAIL, payload: errorPayload };
    }
  };
};
export const FetchGiftsBySchemeAction =
  (schemeName, accessToken) => async (dispatch) => {
    try {
      dispatch({ type: FETCH_GIFTS_BY_SCHEME_REQUEST });

      const response = await axiosInstance.get(
        `/api/get-gift-masters/?offer_scheme_name=${encodeURIComponent(
          schemeName
        )}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      dispatch({
        type: FETCH_GIFTS_BY_SCHEME_SUCCESS,
        payload: response.data,
      });

      return response.data;
    } catch (error) {
      dispatch({
        type: FETCH_GIFTS_BY_SCHEME_FAIL,
        payload: error.response?.data?.message || error.message,
      });
      throw error;
    }
  };
